import muster from '@dbk-legacy/muster';
import { watchValues } from '@dbk-legacy/muster/utils';
import messages from './messages';
import { AsyncStorage } from 'react-native';
export default () => muster()
  .path('locale', {
    async get({ res }) {
      await AsyncStorage.setItem('SelectedRegion', 'Switzerland');
      let SelLanguageCode = await AsyncStorage.getItem('SelectedLanguageCode');
      if (SelLanguageCode !== null && SelLanguageCode !== "undefined") {
        console.log(SelLanguageCode);
        return res.value(SelLanguageCode);
      } else {
        console.log(res);
        return res.value('en-GB');
      }
    }
  })

  .path('messages', ({ res }, { get }) => watchValues(get(['locale']))
    .map(([locale]) => res.value(messages[locale]))
  );

